// src/data/roomImages.js

// 👇 import all images
// import img1 from "../assets/roomsimages/Miransh/Cuddle_cove/IMG_0050.jpg";
// import img2 from "../assets/roomsimages/Miransh/Cuddle_cove/IMG_0053.jpg";
// import img3 from "../assets/roomsimages/Miransh/Cuddle_cove/IMG_0054.jpg";
// import img4 from "../assets/roomsimages/Miransh/Cuddle_cove/IMG_0055.jpg";
// import img5 from "../assets/roomsimages/Miransh/Cuddle_cove/IMG_0058.jpg";
// import img6 from "../assets/roomsimages/Miransh/Cuddle_cove/IMG_0065.jpg";

// import img126 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0126.jpg";
// import img127 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0127.jpg";
// import img133 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0133.jpg";
// import img136 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0136.jpg";
// import img138 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0138.jpg";
// import img144 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0144.jpg";
// import img146 from "../assets/roomsimages/Miransh/Golden_glade/IMG_0146.jpg";

// import img0067 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0067.jpg";
// import img0071 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0071.jpg";
// import img0076 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0076.jpg";
// import img0079 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0079.jpg";
// import img0080 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0080.jpg";
// import img0082 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0082.jpg";
// import img0084 from "../assets/roomsimages/Miransh/Mountain_mist/IMG_0084.jpg";

// import img0086 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0086.jpg";
// import img0089 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0089.jpg";
// import img0092 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0092.jpg";
// import img0098 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0098.jpg";
// import img0099 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0099.jpg";
// import img0106 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0106.jpg";
// import img0108 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0108.jpg";
// import img0109 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0109.jpg";
// import img0110 from "../assets/roomsimages/Miransh/Sage_whisper/IMG_0110.jpg";

// import img0111 from "../assets/roomsimages/Miransh/The_heaven/IMG_0111.jpg";
// import img0114 from "../assets/roomsimages/Miransh/The_heaven/IMG_0114.jpg";
// import img0116 from "../assets/roomsimages/Miransh/The_heaven/IMG_0116.jpg";
// import img0121 from "../assets/roomsimages/Miransh/The_heaven/IMG_0121.jpg";
// import img0125 from "../assets/roomsimages/Miransh/The_heaven/IMG_0125.jpg";
// import img0126 from "../assets/roomsimages/Miransh/The_heaven/IMG_0126.jpg";
// import img0127 from "../assets/roomsimages/Miransh/The_heaven/IMG_0127.jpg";

// import g1 from "../assets/roomsimages/Miransh/Gallery/1777406236097 (1).png";
// import g2 from "../assets/roomsimages/Miransh/Gallery/1777406505353.png";
// import g3 from "../assets/roomsimages/Miransh/Gallery/DroneView1.jpeg";
// import g4 from "../assets/roomsimages/Miransh/Gallery/DroneView2.jpeg";
// import g5 from "../assets/roomsimages/Miransh/Gallery/Droneview3.jpeg";
// import g6 from "../assets/roomsimages/Miransh/Gallery/Droneview4.jpeg";
// import g7 from "../assets/roomsimages/Miransh/Gallery/hall.jpeg";
// import g8 from "../assets/roomsimages/Miransh/Gallery/IMG_0149.jpg";
// import g9 from "../assets/roomsimages/Miransh/Gallery/IMG_0150.jpg";
// import g10 from "../assets/roomsimages/Miransh/Gallery/IMG_0156.jpg";
// import g11 from "../assets/roomsimages/Miransh/Gallery/jacuzi.jpeg";
// import g12 from "../assets/roomsimages/Miransh/Gallery/sea view.jpeg";
// import g13 from "../assets/roomsimages/Miransh/Gallery/WhatsApp Image 2026-05-06 at 12.07.21 PM.jpeg";



// import Mirangehero from '../assets/roomsimages/Miransh/heowebfinal.webp'

// import MirangeheroMobile from '../assets/roomsimages/Miransh/IMG_0264.jpg'



// import s1 from "../assets/roomsimages/Dreamland/seafacing/1.jpg";
// import s2 from "../assets/roomsimages/Dreamland/seafacing/2.jpg";
// import s3 from "../assets/roomsimages/Dreamland/seafacing/3.jpg";
// import s4 from "../assets/roomsimages/Dreamland/seafacing/4.jpg";
// import s5 from "../assets/roomsimages/Dreamland/seafacing/IMG_0245.jpg";
// import s6 from "../assets/roomsimages/Dreamland/seafacing/IMG_0256.jpg";

// import c1 from "../assets/roomsimages/Dreamland/cottage_room/1.jpg";
// import c2 from "../assets/roomsimages/Dreamland/cottage_room/2.jpg";
// import c3 from "../assets/roomsimages/Dreamland/cottage_room/3.jpg";
// import c4 from "../assets/roomsimages/Dreamland/cottage_room/4.jpg";
import c5 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0210.jpg";
import c6 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0211.jpg";
import c7 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0214.jpg";
import c8 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0215.jpg";
import c9 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0216.jpg";
import c10 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0218.jpg";
import c11 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0219.jpg";

// import cp1 from "../assets/roomsimages/Dreamland/couple_room/1.jpg";
// import cp2 from "../assets/roomsimages/Dreamland/couple_room/2.jpg";
// import cp3 from "../assets/roomsimages/Dreamland/couple_room/3.jpg";
// import cp4 from "../assets/roomsimages/Dreamland/couple_room/4.jpg";
import cp5 from "../assets/roomsimages/Dreamland/couple_room/IMG_0222.jpg";
import cp6 from "../assets/roomsimages/Dreamland/couple_room/IMG_0225.jpg";
import cp7 from "../assets/roomsimages/Dreamland/couple_room/IMG_0226.jpg";
import cp8 from "../assets/roomsimages/Dreamland/couple_room/IMG_0227.jpg";
import cp9 from "../assets/roomsimages/Dreamland/couple_room/IMG_0228.jpg";
import cp10 from "../assets/roomsimages/Dreamland/couple_room/IMG_0231.jpg";

// import d1 from "../assets/roomsimages/Dreamland/deluxe_room/1.jpg";
// import d2 from "../assets/roomsimages/Dreamland/deluxe_room/2.jpg";
// import d3 from "../assets/roomsimages/Dreamland/deluxe_room/3.jpg";
// import d4 from "../assets/roomsimages/Dreamland/deluxe_room/4.jpg";
// import d5 from "../assets/roomsimages/Dreamland/deluxe_room/5.jpg";
import d6 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0249.jpg";
import d7 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0250.jpg";
import d8 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0252.jpg";
import d9 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0255.jpg";
import d10 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0256.jpg";

// import lf1 from "../assets/roomsimages/Dreamland/large_family_room/1.jpg";
// import lf2 from "../assets/roomsimages/Dreamland/large_family_room/2.jpg";
// import lf3 from "../assets/roomsimages/Dreamland/large_family_room/3.jpg";
// import lf4 from "../assets/roomsimages/Dreamland/large_family_room/IMG_0237.jpg";

// import mg1 from "../assets/roomsimages/Dreamland/Mega_Group_Room/1.jpg";
// import mg2 from "../assets/roomsimages/Dreamland/Mega_Group_Room/2.jpg";
// import mg3 from "../assets/roomsimages/Dreamland/Mega_Group_Room/3.jpg";
import mg4 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0233.jpg";
import mg5 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0234.jpg";
import mg6 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0235.jpg";
import mg7 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0237.jpg";
import mg8 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0238.jpg";
import mg9 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0240.jpg";
import mg10 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0242.jpg";
import { Images } from "lucide-react";


//heroslider
// import hero1 from '../assets/roomsimages/Dreamland/gallery/hero1.webp';
// import hero2 from '../assets/roomsimages/Dreamland/gallery/hero2.webp';
// import hero3 from '../assets/roomsimages/Dreamland/gallery/hero3.webp';


// 👇 Shrileela imports

// import sh_cp1 from "../assets/roomsimages/Shrileela/Couple_Room/bmbv7lalcnpsovmb17lb.webp";
// import sh_cp2 from "../assets/roomsimages/Shrileela/Couple_Room/dh4z7n8ip0dt8ywcolav.webp";
// import sh_cp3 from "../assets/roomsimages/Shrileela/Couple_Room/jpmzhmb65oksskgrwpk0.webp";
// import sh_cp4 from "../assets/roomsimages/Shrileela/Couple_Room/opseidgqccgydshreivq.webp";
// import sh_cp5 from "../assets/roomsimages/Shrileela/Couple_Room/v3ihercacyrudbvtyctu.webp";
// import sh_cp6 from "../assets/roomsimages/Shrileela/Couple_Room/vxocfpai7o3h0erizqgq.webp";
// import sh_cp7 from "../assets/roomsimages/Shrileela/Couple_Room/wxt5pirsvjandqfmzpyu.webp";



// import sh_sr1 from "../assets/roomsimages/Shrileela/Suit_Room/crs2bzd9x2cmndnts7id.webp";
// import sh_sr2 from "../assets/roomsimages/Shrileela/Suit_Room/d3wwmvee5ncsajcocbah.webp";
// import sh_sr3 from "../assets/roomsimages/Shrileela/Suit_Room/jfinaz5qluncavi3ndjf.webp";
// import sh_sr4 from "../assets/roomsimages/Shrileela/Suit_Room/ol3jjcvwzyldkxxorzcr.webp";
// import sh_sr5 from "../assets/roomsimages/Shrileela/Suit_Room/pajjmuxfxn8xvnw764n6.webp";
// import sh_sr6 from "../assets/roomsimages/Shrileela/Suit_Room/rqx6umpc6do2hrjakx0w.webp";
// import sh_sr7 from "../assets/roomsimages/Shrileela/Suit_Room/vfbi1lxllimiuccetqs0.webp";
// import sh_sr8 from "../assets/roomsimages/Shrileela/Suit_Room/zwk14amykaln6ysf02c8.webp";

// import sh_g1 from "../assets/roomsimages/Shrileela/gallery/hhh.jpeg";
// import sh_g2 from "../assets/roomsimages/Shrileela/gallery/img (1).jpeg";
// import sh_g3 from "../assets/roomsimages/Shrileela/gallery/img (2).jpeg";
// import sh_g4 from "../assets/roomsimages/Shrileela/gallery/img (3).jpeg";
// import sh_g5 from "../assets/roomsimages/Shrileela/gallery/img (4).jpeg";
// import sh_g6 from "../assets/roomsimages/Shrileela/gallery/img (5).jpeg";
// import sh_g7 from "../assets/roomsimages/Shrileela/gallery/img (6).jpeg";
// import sh_g8 from "../assets/roomsimages/Shrileela/gallery/img (7).jpeg";
// import sh_g9 from "../assets/roomsimages/Shrileela/gallery/IMG_2328.JPG.jpeg";
// import sh_g10 from "../assets/roomsimages/Shrileela/gallery/IMG_2329.JPG.jpeg";
// import sh_g11 from "../assets/roomsimages/Shrileela/gallery/IMG_2335.JPG.jpeg";
// import sh_g12 from "../assets/roomsimages/Shrileela/gallery/IMG_2336.JPG.jpeg";
// import sh_g13 from "../assets/roomsimages/Shrileela/gallery/IMG_2337.JPG.jpeg";





// 👇 import all images from clouranary 

// miransh/cuudlecove
const img1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/v1778298311/IMG_0050_oqu1ec.jpg";

const img2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/v1778298301/IMG_0053_wlxshm.jpg";

const img3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/v1778298300/IMG_0054_uqa0ab.jpg";

const img4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/v1778298302/IMG_0055_bmcmvb.jpg";

const img5 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/v1778298301/IMG_0058_oij65l.jpg";

const img6 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/v1778298310/IMG_0065_gnxpyz.jpg";


  // miransh/Golden_glade

const img126 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0126_yawyxp.jpg";

const img127 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0127_eco0u3.jpg";

const img133 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0133_hw2aqg.jpg";

const img136 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0136_nb2yct.jpg";

const img138 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0138_ah8jjx.jpg";

const img144 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0144_vr4xf7.jpg";

const img146 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0146_cjsfll.jpg";

  // miransh/Mountain_mist


const img0067 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0067_ikasts.jpg";

const img0071 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0071_rscit0.jpg";

const img0076 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0076_csdrii.jpg";

const img0079 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0079_qavhfc.jpg";

const img0080 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0080_k8pyst.jpg";

const img0082 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0082_jot92x.jpg";

const img0084 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0084_snyf6p.jpg";

  // miransh/Sage_whisper

const img0086 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0086_wrtkak.jpg";

const img0089 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0089_ujk4m5.jpg";

const img0092 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0092_kawwfx.jpg";

const img0098 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0098_wygxcf.jpg";

const img0099 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0099_jdpog4.jpg";

const img0106 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0106_w4atbr.jpg";

const img0108 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0108_ietfkt.jpg";

const img0109 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0109_ajzg8r.jpg";

const img0110 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0110_h4x7jo.jpg";


const img0111 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0111_dpfddy.jpg";

const img0114 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0114_ehx8vq.jpg";

const img0116 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0116_upyivm.jpg";

const img0121 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0121_fp2inp.jpg";

const img0125 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0125_hzngyc.jpg";

const img0126 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0126_sflknv.jpg";

const img0127 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0127_kbtinj.jpg";




    // miransh/Gallery


const g1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/1777406236097_1_bi1wll.png";


const g2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/1777406505353_n3nygm.png";

const g3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/DroneView1_j6ebuu.jpeg";

const g4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/DroneView2_w1ihe5.jpeg";

const g5 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/Droneview3_jcgrit.jpeg";

const g6 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/Droneview4_ge1q0i.jpeg";

const g7 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/hall_n4re5v.jpeg";

const g8 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0149_jejtsb.jpg";

const g9 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0150_iliuxp.jpg";

const g10 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/IMG_0156_baaopf.jpg";

const g11 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/jacuzi_x9ehyh.jpeg";

const g12 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/sea_view_rm1naz.jpeg";

const g13 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778297944/WhatsApp_Image_2026-05-06_at_12.07.21_PM_a2zi5g.jpeg";


// miransh hero Images


const Mirangehero =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1600/v1778298295/heowebfinal_kw2pap.webp";

  const MirangeheroMobile = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/IMG_0264_km81w7"


  //Dreamland/seafacing

const s1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441178/IMG_0256_lvpcmx.jpg";

const s2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441178/IMG_0245_zcf8jf.jpg";

const s3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441178/1_elefpj.jpg";

const s4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441178/2_ziwsb4.jpg";

const s5 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441178/3_pvidq3.jpg";

const s6 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441178/4_tjq8gj.jpg";



  
  //Dreamland/Cottage


const c1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441165/1_txsjoj.jpg";

const c2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441166/2_qrqa8o.jpg";

const c3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441188/3_sscv0a.jpg";

const c4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441148/4_sqjjdx.jpg";



// import c5 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0210.jpg";
// import c6 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0211.jpg";
// import c7 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0214.jpg";
// import c8 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0215.jpg";
// import c9 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0216.jpg";
// import c10 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0218.jpg";
// import c11 from "../assets/roomsimages/Dreamland/cottage_room/IMG_0219.jpg";



  //Dreamland/couple_room


const cp1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441165/1_mal00o.jpg";

const cp2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441158/2_ykqjvz.jpg";

const cp3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441171/3_nn4i7c.jpg";

const cp4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441156/4_eljrnt.jpg";
// import cp5 from "../assets/roomsimages/Dreamland/couple_room/IMG_0222.jpg";
// import cp6 from "../assets/roomsimages/Dreamland/couple_room/IMG_0225.jpg";
// import cp7 from "../assets/roomsimages/Dreamland/couple_room/IMG_0226.jpg";
// import cp8 from "../assets/roomsimages/Dreamland/couple_room/IMG_0227.jpg";
// import cp9 from "../assets/roomsimages/Dreamland/couple_room/IMG_0228.jpg";
// import cp10 from "../assets/roomsimages/Dreamland/couple_room/IMG_0231.jpg";




  //Dreamland/deluxe_room
const d1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441179/1_f8g2h8.jpg";

const d2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441162/2_udzmgc.jpg";

const d3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441154/3_fqsels.jpg";

const d4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441172/4_qjwgu6.jpg";

const d5 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441158/5_va5b2o.jpg";


// import d6 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0249.jpg";
// import d7 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0250.jpg";
// import d8 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0252.jpg";
// import d9 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0255.jpg";
// import d10 from "../assets/roomsimages/Dreamland/deluxe_room/IMG_0256.jpg";


  //Dreamland/large_family_room

const lf1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441189/1_qzqgmk.jpg";

const lf2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441189/2_jfibdo.jpg";

const lf3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441189/3_fekgpf.jpg";

const lf4 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441189/IMG_0237_sohuhs.jpg";

const mg1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441181/1_byyhtk.jpg";

const mg2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441196/2_atrl5k.jpg";

const mg3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778441192/3_exy8hb.jpg";
// import mg4 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0233.jpg";
// import mg5 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0234.jpg";
// import mg6 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0235.jpg";
// import mg7 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0237.jpg";
// import mg8 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0238.jpg";
// import mg9 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0240.jpg";
// import mg10 from "../assets/roomsimages/Dreamland/Mega_Group_Room/IMG_0242.jpg";



const hero1 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1600/v1778441144/hero1_ofdkw1.webp";

const hero2 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1600/v1778441145/hero2_v7kqpb.webp";

const hero3 =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1600/v1778441146/hero3_oqy147.webp";





// // 👇 Shrileela imports




// 






// shrileelaCopuleRoom
const sh_cp1 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/wxt5pirsvjandqfmzpyu_ynub4e.webp";

const sh_cp2 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/vxocfpai7o3h0erizqgq_lqfkf1.webp";

const sh_cp3 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/dh4z7n8ip0dt8ywcolav_kwkges.webp";

const sh_cp4 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/jpmzhmb65oksskgrwpk0_oqfkyl.webp";

const sh_cp5 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/v3ihercacyrudbvtyctu_kkjjss.webp";

const sh_cp6 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/opseidgqccgydshreivq_wxct9w.webp";

const sh_cp7 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/bmbv7lalcnpsovmb17lb_nbsw7t.webp";

// shrileelaSuiteRoom

const sh_sr1 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/zwk14amykaln6ysf02c8_zleak6.webp";

const sh_sr2 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/vfbi1xllimiuccetqs0_xn7d03.webp";

const sh_sr3 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/rqx6umpc6do2hrjakx0w_cslioq.webp";

const sh_sr4 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/ol3jjcvwzyldkxxorzcr_tkdqrg.webp";

const sh_sr5 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/pajjmuxfxn8xvnw764n6_yks08n.webp";

const sh_sr6 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/jfinaz5qluncavi3ndjf_akfeqp.webp";

const sh_sr7 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/d3wwmvee5ncsajcocbah_osvjhv.webp";

const sh_sr8 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto/crs2bzd9x2cmndnts7id_qbuipv.webp";




// Add these imports (adjust path as needed)

// import sh_g14 from "../assets/roomsimages/Shrileela/gallery



const sh_g1 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262887/hhh_h2umez.jpg";
const sh_g2 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262886/img_1_qcvwaa.jpg";
const sh_g3 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262889/img_2_nlllu6.jpg";
const sh_g4 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262890/img_3_cdutr8.jpg";
const sh_g5 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262892/img_4_jhf9k0.jpg";
const sh_g6 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262895/img_5_x9nmqj.jpg";
const sh_g7 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262896/img_6_havzvo.jpg";
const sh_g8 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262899/img_7_gtoc1a.jpg";
const sh_g9 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262912/IMG_2328.JPG_kzsg7v.jpg";
const sh_g10 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262915/IMG_2329.JPG_iknsxv.jpg";
const sh_g11 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262911/IMG_2335.JPG_wc2e2h.jpg";
const sh_g12 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262908/IMG_2336.JPG_mmtxm4.jpg";
const sh_g13 = "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778262908/IMG_2337.JPG_ogb7g4.jpg";



// 👇 structured export
export const roomImages = {
  miransh: {
    cuddleCove: [img3, img1, img4, img5, img6, img2],
    goldenGlade: [img138, img146, img144, img136, img133, img127, img126],
    mountainMist: [img0067, img0079, img0080, img0071, img0076, img0082, img0084],
    sageWhisper: [img0086, img0089, img0092, img0098, img0108, img0106, img0109, img0110, img0099],
    theHeaven: [img0111, img0114, img0116, img0121, img0127, img0126, img0125],
 gallery: [g1, g2, g3, g4, g5, g6, g7, g8, g9, g10, g11, g12, g13],
 heroimages:[Mirangehero,MirangeheroMobile],
  },

  dreamland: {
    seaFacing: [s2, s3, s4, s5,s1, s6],
    cottageRoom: [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11],
    coupleRoom: [cp1, cp2, cp3, cp4, cp5, cp6, cp7, cp8, cp9, cp10],
    deluxeRoom: [d1, d2, d3, d4, d5, d6, d7, d8, d9, d10],
    largeFamilyRoom: [lf1, lf2, lf3, lf4],
    megaGroupRoom: [mg1, mg2, mg4, mg3, mg5, mg6, mg7, mg8, mg9, mg10],
    heroslider:[hero1,hero2,hero3],
  },

  shrileela: {
    coupleRoom:[sh_cp5,sh_cp6,sh_cp4,sh_cp1,sh_cp3,sh_cp2,sh_cp7],
    suitRoom: [sh_sr1,sh_sr7,sh_sr3,sh_sr6,sh_sr2,sh_sr5,sh_sr4,sh_sr8],
      gallery: [sh_g1,sh_g2,sh_g3,sh_g4,sh_g5,sh_g6],
}
}